<template>
  <div>
    <template>
      <h2 class="font-weight-light primary--text">Añadir Usuario</h2>
      <v-form ref="formulario">
        <v-text-field label="Email" v-model="user.email" :rules="emailRules"></v-text-field>
        <v-select label="Rol de Usuario" :items="roles" v-model="user.role_id" item-value="id" :rules="requiredRules"></v-select>
        <v-checkbox label="Puede administrar la cuenta We Help" v-model="user.is_admin" :false-value="0" :true-value="1"></v-checkbox>
        <div class="text-right mb-4">
          <v-btn color="primary" @click="submit">Añadir Usuario</v-btn>
        </div>
      </v-form>
    </template>
  </div>
</template>
<script>
export default {
  props: {
    submitFn: {
      type: Function
    },
    sucursal: {
      type: String
    }
  },
  data() {
    return {
      user: {
        email: '',
        role_id: null,
        is_admin: 0
      },
      emailRules: [
        v => /.+@.+/.test(v) || 'E-mail inválido'
      ],
      requiredRules: [
        v => {
          if (v === null) {
            return false || 'Campo Requerido'
          } else {
            return true
          }
        }
      ]
    }
  },
  computed: {
    roles() {
      return this.$store.getters['provider/roles']
    }
  },
  methods: {
    resetUser() {
      this.$refs.formulario.reset()
      this.user = {
        email: '',
        is_admin: 0,
        role_id: null
      }
    },
    async submit() {
      if (!this.$refs.formulario.validate())
        return
      const usuario = JSON.parse(JSON.stringify(this.user))
      const added = await this.$store.dispatch('provider/addUserToBranch', usuario)
      if (added) {
        this.$store.commit('showSnackBar', 'Usuario Añadido')
        this.resetUser()
      } else {
        this.$store.commit('showSnackBar', 'Usuario ya existe')
      }

    }
  },
}
</script>

